<div>
  <vdr-card
    title="{{ 'certification.title' | translate }}"
    [paddingX]="true"
    style="margin-bottom: 2%"
  >
    <div class="certification-manager">
      <!-- Loading State -->
      <div *ngIf="isLoading$ | async" class="loading">
        <clr-icon shape="spinner" class="spinner"></clr-icon>
        {{ "certification.loading" | translate }}
      </div>

      <!-- Content -->
      <div *ngIf="!(isLoading$ | async)">
        <!-- Selected certifications summary -->
        <div
          *ngIf="(selectedCertifications$ | async)?.length > 0"
          class="selected-summary"
        >
          <h4>
            {{ "certification.selected" | translate }}
            ({{ (selectedCertifications$ | async)?.length }})
          </h4>

          <div class="selected-items">
            <div
              *ngFor="let certification of selectedCertifications$ | async"
              class="selected-item"
            >
              <img
                [src]="certification.source + '?preset=small'"
                [alt]="certification.preview"
              />
              <button
                type="button"
                class="remove-btn"
                (click)="toggleCertification(certification.id)"
                title="{{ 'certification.remove' | translate }}"
                [disabled]="isSaving$ | async"
              >
                <clr-icon shape="times"></clr-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Certification grid -->
        <div class="certifications-grid">
          <h4>{{ "certification.available" | translate }}</h4>

          <!-- Empty state -->
          <div
            *ngIf="
              (allCertifications$ | async)?.length === 0 &&
              !(isLoading$ | async)
            "
            class="empty-state"
          >
            <clr-icon shape="certificate" size="48"></clr-icon>
            <p>{{ "certification.empty_title" | translate }}</p>
            <small>{{ "certification.empty_desc" | translate }}</small>
          </div>

          <!-- Grid container -->
          <div
            class="grid-container"
            *ngIf="(allCertifications$ | async)?.length > 0"
          >
            <div
              *ngFor="let certification of allCertifications$ | async"
              class="certification-item"
              [class.selected]="isSelected(certification.id)"
              (click)="toggleCertification(certification.id)"
              [class.disabled]="isSaving$ | async"
            >
              <div class="image-container">
                <img
                  [src]="certification.source + '?preset=small'"
                  [alt]="certification.preview"
                  loading="lazy"
                />
                <div class="overlay" *ngIf="isSelected(certification.id)">
                  <clr-icon shape="check" class="check-icon"></clr-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- Action buttons -->
          <div class="actions" *ngIf="(allCertifications$ | async)?.length > 0">
            <button
              type="button"
              class="btn btn-sm btn-outline"
              (click)="selectAll()"
              [disabled]="isSaving$ | async"
            >
              {{ "certification.select_all" | translate }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-outline"
              (click)="clearAll()"
              [disabled]="
                (isSaving$ | async) || (selectedIds$ | async)?.length === 0
              "
            >
              {{ "certification.clear_all" | translate }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-primary"
              (click)="saveCertifications()"
            >
              <clr-icon shape="floppy" *ngIf="!(isSaving$ | async)"></clr-icon>
              <clr-icon
                shape="spinner"
                class="spinner"
                *ngIf="isSaving$ | async"
              ></clr-icon>

              {{
                (isSaving$ | async)
                  ? ("certification.saving" | translate)
                  : ("certification.save" | translate)
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </vdr-card>
</div>
